import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 0;
`;
export const Row = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`;
export const Card = styled.section`
  padding: 20px;
  background: ${({ theme }) => theme.colors.backgroundElevated};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.lg};
  min-width: 0;
`;
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
`;
export const Muted = styled.p`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 13px;
  line-height: 1.6;
  margin: 6px 0;
  overflow-wrap: anywhere;
`;
export const Notice = styled.div<{ $error?: boolean }>`
  padding: 12px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme, $error }) => ($error ? theme.colors.status.danger : theme.colors.text.primary)};
  border-left: 3px solid
    ${({ theme, $error }) => ($error ? theme.colors.status.danger : theme.colors.status.warning)};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;
export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  min-width: 180px;
  flex: 1;
`;
export const Input = styled.input`
  font: inherit;
  color: inherit;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 6px;
  padding: 10px;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
`;
export const Select = styled.select`
  font: inherit;
  color: inherit;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 6px;
  padding: 10px;
  max-width: 100%;
`;
export const Textarea = styled.textarea`
  font: inherit;
  color: inherit;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 6px;
  padding: 10px;
  min-height: 90px;
  width: 100%;
  box-sizing: border-box;
`;
export const TableBox = styled.div`
  overflow: auto;
  max-height: 480px;
`;
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  th,
  td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    vertical-align: top;
    overflow-wrap: anywhere;
    max-width: 320px;
  }
  th {
    position: sticky;
    top: 0;
    background: ${({ theme }) => theme.colors.backgroundElevated};
    z-index: 1;
  }
  button {
    white-space: nowrap;
  }
`;
export const Nav = styled.nav`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;
export const NavItem = styled(Link)<{ $active?: boolean }>`
  display: block;
  padding: 9px 12px;
  border-radius: 8px;
  color: ${({ theme, $active }) => ($active ? '#fff' : theme.colors.text.primary)};
  background: ${({ theme, $active }) => ($active ? theme.colors.primary : theme.colors.surface)};
  text-decoration: none;
  font-size: 13px;
`;
export const Small = styled.small`
  display: block;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.text.muted};
  line-height: 1.5;
  overflow-wrap: anywhere;
`;
